/**
 * @generated SignedSource<<0b4273117571a9bd20acede1795822e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentStyleCardCarouselWidgetSectionsAtomBase$data = {
  readonly __typename: "Article";
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase";
} | {
  readonly __typename: "Section";
  readonly fullSectionPath: ReadonlyArray<{
    readonly entityId: string;
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase";
};
export type atomsCurrentStyleCardCarouselWidgetSectionsAtomBase$key = {
  readonly " $data"?: atomsCurrentStyleCardCarouselWidgetSectionsAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentStyleCardCarouselWidgetSectionsAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase"
};

(node as any).hash = "7ab4256fa23b663a6dfa00249fe68fe3";

export default node;
